.container {
  width: 100%;
}

.infoMessage {
  margin-top: 0;
}

/* The help icon and the box border follow the text colour, light on petrol and dark elsewhere. */
.container > :first-child button {
  color: inherit;
}

.container .infoMessage {
  border-color: currentColor;
}
